// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__1z9bj","summary":"CartItem_summary__3pewl","price":"CartItem_price__3uQo7","amount":"CartItem_amount__1LQbs","actions":"CartItem_actions__VJPpA"};